import { Step } from '@tiptap/pm/transform'

export const mergeSteps = (steps: Step[]): Step[] => {
  if (steps.length < 2) return steps
  const merged = steps.reduce((mergedSteps, step) => {
    const lastStep = mergedSteps[mergedSteps.length - 1]
    const mergedStep = lastStep ? lastStep.merge(step) : null
    if (mergedStep) {
      /* eslint-disable no-param-reassign */
      mergedSteps[mergedSteps.length - 1] = mergedStep
    } else {
      mergedSteps.push(step)
    }
    return mergedSteps
  }, [])
  return merged
}
